<script setup lang="ts">
import { PinInputInput, PinInputRoot } from 'radix-vue'
import {ref, watch} from "vue";
const emit = defineEmits(['complete']);

const value = ref<string[]>()
const model = defineModel<string>()

watch(value, () => {
  model.value = value.value?.join('') || '';
});
</script>

<template>
    <PinInputRoot
        id="pin-input"
        placeholder="○"
        v-model="value"
        class="flex gap-2 items-center"
        @complete="emit('complete', value)"
    >
      <PinInputInput
          v-for="(id, index) in 6"
          :key="id"
          :index="index"
          :id="'pin-input-' + index"
          class="aspect-square w-14 text-xl text-center outline-none border rounded-lg bg-neutral-50"
      />
    </PinInputRoot>
</template>
